
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea5c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea5c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $34324abf1a7a7e5b$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["ftvzK","index.5f52255b.js","cDKbj","platform.80c48446.png","kRi89","base.eb0106c8.png","gNXWD","star.a30b4b37.png","786Ft","tileset_x1.841278b5.png","hXlLb","player1.da17c7ee.png","ezx2p","laser.e2c1f0af.png","6Am91","player_dash.45cffc5d.png","2Nsp3","playerextra.af9933c9.png","f3YHZ","teacher_spritesheet.eabd03aa.png","lMTNt","mondongo.c448b6bb.mp3","kZKwf","intro.718b800f.wav","Sd2pk","body.f492e937.wav","gvDuJ","WrongAnswer.1f57e4bb.wav","OTWLd","BabaBooey.7758d497.mp3","8WUf5","pixel-cyberpunk-interior.a06c91ac.png","jQuA0","longray.ce76bece.png","2xUfI","PauseButton.4b04c91d.png","ifZZg","PlayButton.5d116044.png","9rFkn","mute.5aa63786.png","aJcdC","playSound.014cb9ac.png","04JsH","lasersprite2.e309f43b.png","hmVRp","laserspriteVert.92a4eeb1.png","hmZdl","spritesheet_libro.574c6ee7.png","2W0fD","spritesheet_unity.94ef7554.png","j59hy","spritesheet_teclado.3eafa626.png","jKhVl","spritesheet_vscode.1050df19.png","53S5w","spritesheet_domjudge.5af6d62b.png","1DehT","disparador.7b84623a.png","5CgnE","dash.d980bb93.wav","kCuaR","damage.98cb443b.mp3","dofj6","background.9ec20868.png","8r5E9","backTable.73605637.png","fd1zv","nota6.bdfb6fea.png","aAsAj","nota5.b89fa7ea.png","2rKhP","nota4.65d55f7d.png","2da2V","nota3.fd26946d.png","6DFoZ","nota2.90e68571.png","ZgG3F","nota1.38b84bcc.png","jEBq3","laser_beam.19c22689.wav","lbY3R","full_screen.bd2bea63.png","4WhTv","window_mode.0f3cecb5.png","u6k2y","chalk_shoot.cbdb21ff.wav","l7rsl","collect.df642d18.wav","ebbCv","start.0def7539.wav","bBbFl","attack.899d3d56.wav","aB1Ai","Evil_Laugh.766b648a.wav"]'));


//# sourceMappingURL=index.runtime.faa441c8.js.map
